import { EmailData } from './email-viewer-types';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowSquareOutIcon } from '@phosphor-icons/react';
import PDFViewer from '../pdf-viewer/PDFViewer';
import { XlsxViewer } from '@/components/xlsx-viewer/XlsxViewer';
import { isExcelFile } from './utils';
import { cn } from '@/lib/utils';

const borderedAttachementStyle = 'border border-gray-200 rounded-xs';

export function EmailAttachment({ emailData }: { emailData: EmailData }) {
  const hasAttachments = !!emailData.attachments?.length;

  if (!hasAttachments) {
    return (
      <Card>
        <CardContent className="flex justify-center items-center p-8">
          <span className="text-xs text-gray-400 italic tracking-wide opacity-20">
            No attachments found
          </span>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="p-1 space-y-2">
      {emailData.attachments?.map((attachment) => (
        <Card key={attachment.id} onClick={(e) => e.stopPropagation()}>
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <div className="text-sm font-medium break-words">
                {attachment.fileName} (
                {(attachment.sizeBytes / 1024).toFixed(2)} KB)
              </div>
              <Button
                variant="link"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(attachment.s3Url, '_blank');
                }}
                className="h-auto p-2"
              >
                <ArrowSquareOutIcon className="w-4 h-4" />
              </Button>
            </CardTitle>
          </CardHeader>
          <CardContent>
            {/* Content based on file type */}
            {attachment.mimeType?.startsWith('image/') ? (
              <div className="w-full flex justify-center">
                <img
                  src={attachment.s3Url}
                  alt={attachment.fileName}
                  className={cn(
                    borderedAttachementStyle,
                    'h-auto max-h-[500px]',
                  )}
                />
              </div>
            ) : attachment.mimeType === 'application/pdf' ||
              attachment.fileName?.toLowerCase().endsWith('.pdf') ? (
              <PDFViewer url={attachment.s3Url} />
            ) : isExcelFile(attachment) ? (
              <XlsxViewer
                url={attachment.s3Url}
                fileName={attachment.fileName}
              />
            ) : (
              <a
                href={attachment.s3Url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-sm"
              >
                Download File
              </a>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
